import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import screenfull from 'screenfull';
import { SallerBuyerService } from '../dashboard/sallerBuyer.service';
import { BidStockService } from '../auction-join/services/bid-stock.service ';
import { AuctionStockService } from '../auction-join/services/auction-stock.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ConfirmdialogServiceService } from 'src/app/shared/confirmation-dialog/confirmdialog-service.service';
import { SharedService } from 'src/app/shared/services1/shared.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConnectionService } from '../auction-join/services/connection.service';
import { COUNTRY_CODES } from 'src/assets/country-codes';
import { SocketAuctionJoinService } from '../auction-join/services/socket-auction-join.service';
import { allConstant } from 'src/app/_helpers/const';

@Component({
  selector: 'app-youtube-banner',
  templateUrl: './youtube-banner.component.html',
  styleUrls: ['./youtube-banner.component.scss'],
   providers: [SocketAuctionJoinService, ConnectionService],

})
export class YoutubeBannerComponent implements OnInit, AfterViewInit, OnDestroy {
  // aprovalStatus: boolean = false;
  private destroy$ = new Subject<void>();
  historyData: any = [{ isFrontEnd: true }];
  images = ['../../../assets/img/imageres.jpg', '../../../assets/img/7-imga.jpg'];
  auctionId: any = '658ae641c557f13c4f92042a';
  auctionDetailsData: any;
  responseData: any;
  currentUser: any;
  showVehicle: any;
  bidedData: any;
  isSold: boolean = false;
  isUnSold: boolean = false;
  isUnderApproval: boolean = false;
  isPause: boolean = false;
  currentVehicleOnBid: any;
  upcomingInventoryList: any;

  showImage: boolean = true;  // Controls image visibility
  showReservePrice: boolean = true;  // Controls reserve price visibility
  aprovalStatus: boolean = true;  // Example variable for approval status
  cycleInterval: any;
  laneDetails: any;
  laneId: any;
  BidSettings: any  = {
    isEmitted: false,
    lastBidCount: 0
  };
  constructor(
    private bidStockService: SocketAuctionJoinService,
    private auctionService: AuctionStockService,
    private service: SallerBuyerService,
    private router: ActivatedRoute,
      private modalService: BsModalService,
    private toastr: ToastrService,
    public sharedService: SharedService,
    private connectionService:ConnectionService
  ) {
  }
  ngOnInit() {
    this.connectionService.startPinging();
    this.setupConnectionListeners();
    this.wakeupfunction();
    this.currentUser = { _id: '644bb2165b522f97549c00a6' };
    this.router.queryParams.subscribe(async (params) => {
      this.auctionId = params['id'];
      this.laneId = params['laneId'];
      await this.getAuctionDetail(this.auctionId);
      this.firstTimeFunctionInitialization();
    });
    this.receiveReservePriceStatus();
    this.receiveMarketPriceStatus();
    this.startReservePriceCycle();
    this.initNetworkSpeedMonitoring();
  }

  async firstTimeFunctionInitialization() {
    this.isCarApprovedSubscribe();
    this.lastFiveBidsSubscribe();
    this.onlineBidSubscription();
    await this.getPendingCar();
    this.forceRefreshSubscribe();
    this.bannerRefreshSubscribe();
    this.auctionResumePauseFunSubscribe();
    this.isSoldSubscribe();
    this.isUnSoldSubscribe();
    this.getSkipStatusSubscribe();
    this.isUnderApprovalSubscribe();
    this.isAuctionVehicleReloadSubscription();
    this.RevceiveFunctionalAudioMessageSubscription();
    this.VehicleTimerCounterUPSubscription();
    this.isConnectedSubscription();
    this.isDisconnectSubscription();
  }

  bidTimeCounterUp:any;
  VehicleTimerCounterUPSubscription() {
    this.bidStockService.vehicleTimerSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status) {
            this.bidTimeCounterUp = res;
          } else {
            this.bidTimeCounterUp = res;
          }
        }
      })
  }

  receiveReservePriceStatus() {
    this.bidStockService.receiveReservePriceStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res && Object.keys(res).length !== 0 && res.constructor === Object) {
          this.isShowReservePriceObj = res;
        }
      });
  }
  
  receiveMarketPriceStatus() {
      this.bidStockService.receiveMarketPriceStatus()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
  
          if (res && Object.keys(res).length != 0 && res.constructor === Object) {
            this.isShowMarketPriceObj = res;
          }
        })
    }
  

  speakText(text): void {
    this.sharedService.speak(text);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.bidStockService.unsubscribeReceiveFunctionalAudioMessage();
    this.bidStockService.socketend(this.auctionId, this.currentUser._id, this.laneDetails?._id);
    if (this.cycleInterval) {
      clearInterval(this.cycleInterval);  // Clean up the interval on destroy
    }
    this.connectionService.stopPinging();
    this.cleanupNetworkSpeedMonitoring();
  }
  
  startReservePriceCycle() {
    this.cycleInterval = setInterval(() => {
      this.showReservePrice = !this.showReservePrice;
    }, 3000);
  }

  ngAfterViewInit() {
    this.isPause = this.auctionDetailsData?.isAuctionPaused;
    // this.openModal();
  }

  toggleFullScreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }
  async getAuctionDetail(id: any) {
    const data: any = await this.service.auctionDetail({ auctionId: id }).toPromise();

    if (data.result) {
      this.auctionDetailsData = data.result;
      this.laneDetails = this.auctionDetailsData.lanes
        .find((lane: any) => lane._id === this.laneId);
      this.isPause = this.laneDetails?.pause;
    }
  }

  isSoldSubscribe() {
    this.bidStockService.isSoldSubscription()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.isSold = res.status;
            setTimeout(() => {
              this.allReloadFunction();
            }, 5000);
          }
        }
      })
  }

  isUnderApprovalSubscribe() {
    this.bidStockService.isUnderApprovalSubscribe()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.isUnderApproval = res.status;
            setTimeout(() => {
              this.allReloadFunction();
            }, 5000);
          }
        }
      })
  }

  isUnSoldSubscribe() {
    this.bidStockService.isUnSoldSubscription()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.isUnSold = res.status;
            setTimeout(() => {
              this.allReloadFunction();
            }, 5000);
          }
        }
      })
  }

  auctionResumePauseFunSubscribe() {
    this.bidStockService
      .pauseAuction()
      .subscribe((val: any) => {
        if (val == true) {
          this.isPause = true;
        } else if (val === false) {
          this.isPause = false;
        }
      });
  }

  lastFiveBidsSubscribe() {
    this.bidStockService.lastFiveBidsSubscription(this.auctionId)
      .subscribe((res: any) => {
        if (res) {
          if(this.historyData?.length > 0 && this.BidSettings?.lastBidCount > 1){
            const timediff = -(this.getTimeDiffrence(res[0]?.createdAt));
            if(timediff >= allConstant.bidSetting.bidTimeGap){
              if (this.BidSettings.lastBidCount > 2 && this.isShowNetWarning == false) {
                // this.isShowNetWarning = true;
                const interval = setInterval(() => {
                  this.updateNetworkInfo();
                  // stop when warning becomes false
                  if (!this.isShowNetWarning) {
                    clearInterval(interval);
                  }
                }, 2000); // runs every 2 seconds
              }
              if(this.isShowNetWarning == false){
                this.updateNetworkInfo();
              }
            }
          }
          this.BidSettings['lastBidCount'] += 1;
          this.historyData = res;
        }
      })
  }

  onlineBidSubscription() {
    this.bidStockService.onlineBidAmountSubscription()
      .subscribe((res: any) => {
        
        if (res > 0) {
          this.speakText(`${res} online`)
        }
      })
  }

  isAuctionVehicleReloadSubscription() {
    this.bidStockService.isAuctionVehicleReloadSubscription()
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            this.allReloadFunction();
          }
        }
      })
  }


  allReloadFunction() {
    this.allResetValues();
    this.isSold = false;
    this.isUnSold = false;
    this.isUnderApproval = false;
    this.getPendingCar();
  }

  isCarApprovedSubscribe() {
    this.bidStockService
      .isCarApproved()
      .subscribe((val: any) => {
        if (val === true || val === false) {
          this.aprovalStatus = val ? true : false;
        }
      });
  }

  getSkipStatusSubscribe() {
    this.bidStockService
      .getSkipStatus(this.auctionId, this.currentVehicleOnBid?.inventoryId)
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.status == true) {
            setTimeout(() => {
              this.allReloadFunction();
            }, 1000);
          }
        }
      });
  }

  forceRefreshSubscribe() {
    this.bidStockService
      .forceRefresh()
      .subscribe((val: any) => {
        /*  force refresh */
        if (val?.status == true) {
          if (this.currentVehicleOnBid?.inventoryId != val?.inventoryId) {
            this.allReloadFunction();
          }
        }
      });
  }

  bannerRefreshSubscribe() {
    this.bidStockService
      .bannerRefreshSubscribe()
      .subscribe((val: any) => {
        /*  force refresh */
        if (val?.status == true) {
          if (this.currentVehicleOnBid?.inventoryId != val?.inventoryId) {
            this.allReloadFunction();
          }
        }
      });
  }

  emitIsCarApproved() {
    this.bidStockService.emitIsCarApproved(this.auctionId, this.currentVehicleOnBid?.inventoryId, this.laneDetails?._id);
  }

  emitLastFiveBids() {
    this.bidStockService.emitLastFiveBides(this.auctionId, this.currentVehicleOnBid?.inventoryId, this.laneDetails?._id);
  }

  joinAcution() {
    this.bidStockService.joinAuction(this.auctionId, this.currentVehicleOnBid.inventoryId, this.currentUser._id, this.auctionDetailsData?.auctionStart, this.laneDetails?._id);
  }

  GetAuctionInformation(auctionId: any): Promise<any> {
    return this.auctionService
      .auctionVehicleList({
        pageLimit: 3,
        page: 1,
        auctionId: auctionId,
        inventoryStatus: 2,
        userId: this.currentUser._id,
        status: 'pending',
      })
      .toPromise();
  }
  isShowReservePriceObj: any;
  isShowMarketPriceObj: any;

  async getPendingCar(): Promise<any> {
    
    let data = {
      auctionId: this.auctionId,
      page: 1,
      pageLimit: 4,
      lane:  this.laneDetails?.lane
    };

    this.showImage = false;
    const response: any = await this.auctionService.getPendingAuctionVehicle(data).toPromise();
    this.showImage = true;

    if (response?.status) {
      this.currentVehicleOnBid = {};
      if (response?.result?.length > 1) {
        this.currentVehicleOnBid = response.result[0];
        this.upcomingInventoryList = response.result.slice(1);
      } else {
        this.currentVehicleOnBid = response.result[0];
        this.upcomingInventoryList = [];
      }

      if (response?.result?.length === 0) {
        window.location.href = '/auctions';
      }

      // Set reserve price visibility
      this.isShowReservePriceObj = {status: this.currentVehicleOnBid?.showReservePrice, reservePrice: this.currentVehicleOnBid?.reservePrice};

      //Set martket price visibility
       this.isShowMarketPriceObj = { status: this.currentVehicleOnBid.showMarketPrice, marketPrice: this.currentVehicleOnBid?.marketPrice };

      this.joinAcution();
      this.BidSettings['isEmitted'] = true;
      this.BidSettings['lastBidCount'] = 0;
      this.emitLastFiveBids();
      this.emitIsCarApproved();

      // Update image URLs with CDN base URL
      this.currentVehicleOnBid.images = this.currentVehicleOnBid.images.map((img: string) =>
        this.sharedService.cloudFrontUrl("500x400", img)
      );
    }
  }

  allResetValues() {
    this.showVehicle = '';
    this.historyData = [];
  }


 
    wakeupfunction() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  isOnline = true;
  isDisconnected: boolean = false;
  isConnected: boolean = false;

  private setupConnectionListeners() {
    this.connectionService.status$.subscribe((isOnline) => {

      if (this.isOnline == false && isOnline == true) {
        this.isOnline = true;
        this.isDisconnected = false;
        this.updateNetworkWarningState();
        this.allReloadFunction();
        return;
      }
      if (this.isOnline == true && isOnline == false) {
        this.isOnline = false;
        this.isDisconnected = true;
        this.updateNetworkWarningState();
        this.toastr.show("Connection Lost!!!", 'Warning');
      }
    });
  }

   handleVisibilityChange = () => {
    if(!document.hidden){
      this.connectionService.startPinging();
    }
    if (document.hidden) {
      this.connectionService.stopPinging();
      this.backgroundMusic.pause();
    } else {
      if(this.isOnline == true){
        this.allReloadFunction();
        this.backgroundMusic?.paused ? this.backgroundMusic.play() : '';
      }else{
        this.toastr.show("Connection Lost!!!", 'Warning');
      }
    }
  }

  getTimeDiffrence(endDate: any) {
    let start = new Date().getTime();
    let end = new Date(endDate).getTime();

    let diff = end - start;
    let seconds = Math.floor((diff / 1000) % 60);
    return seconds;
  }

  RevceiveFunctionalAudioMessageSubscription() {
    this.bidStockService.RevceiveFunctionalAudioMessageSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res && Object.keys(res).length != 0 && res.constructor === Object) {
          if (res.type) {
            res.type == 'background' ? this.playBackgroundMusic(res) : this.playBeep(res.link, res.duration, res);
          }
        }
      })
  }

  playBeep(message, durationtime, data:any = null) {
    if(data?.type == 'online-bid'){
      //this.staticOnlineBid();
      return;
    }
    let audio = new Audio(message);
    audio.volume = 0.5;
    if (!this.currentUser.isAuctionMute) {
      //audio.play()
    };
  }

  playMessage(message: any) {
    var audio = new Audio(message);

    if (!this.currentUser.isAuctionMute) { 
      //audio.play() 
    };
  }

  async waitForUserClick(): Promise<MouseEvent> {
    return new Promise((resolve) => {
      const listener = (event: MouseEvent) => {
        window.removeEventListener('click', listener);
        resolve(event);
      };
      window.addEventListener('click', listener);
    });
  }

  backgroundMusic: any;
  playBackgroundMusic(data: any) {
    if (data && data?.link && data?.link != '') {
      this.backgroundMusic = new Audio(data?.link);
      this.backgroundMusic.loop = data?.loop;
      this.backgroundMusic.volume = data?.volume;
      if (!this.currentUser.isAuctionMute) {
        // this.backgroundMusic.play().catch(async (reason: any) => {
        //   const event = await this.waitForUserClick();
        //   this.backgroundMusic.play();
        // });
      };
    }
  }
  
    @ViewChild("templateModal") templateModal: TemplateRef<any>;
  // staticOnlineBid(){
  //   this.playBeep('assets/ringtone-online.wav', 2000)
  // }
  dialogRef: BsModalRef<any>;
  openModal() {
    this.dialogRef = this.modalService.show(this.templateModal);
  }

getCountryIsoCode(countryCode: string): string {
  return COUNTRY_CODES[countryCode] || '';
}

getFlagUrl(countryCode: string): string {
  const iso = this.getCountryIsoCode(countryCode);
  return iso ? `https://flagcdn.com/16x12/${iso}.png` : '';
}

  isDisconnectSubscription() {
    this.bidStockService
      .isDisconnectSubscription()
      .subscribe((val: any) => {
        if (val && Object.keys(val).length != 0 && val.constructor === Object) {
          this.toastr.warning("auction disconnected and trying to connect");
          this.isDisconnected = true;
          this.isConnected = false;
          this.updateNetworkWarningState();
        }
      });
  }

  connectioinCount = 0;
  isConnectedSubscription() {
    this.bidStockService
      .isConnectedSubscription()
      .subscribe((val: any) => {
        if (val && Object.keys(val).length != 0 && val.constructor === Object) {
          this.toastr.success("auction connected");
          this.isOnline = true;
          if(this.isDisconnected === true && this.connectioinCount > 0){
            this.allReloadFunction();
          }
          this.isDisconnected = false;
          this.isConnected = true;
          this.connectioinCount += 1;
          this.updateNetworkWarningState();
        }
      });
  }

  //#region <-------------START NETWORK SPEED SECTION------------->
    beepFlag: boolean = false;
  netSpeedMbps: number | null = null;
  netType: string = 'unknown';
  netRttMs: number | null = null;
  isShowNetWarning = false;
  private browserConnection: any = null;
  private readonly networkChangeHandler = () => this.updateNetworkInfo();

  private initNetworkSpeedMonitoring() {
    const nav: any = navigator;
    this.browserConnection = nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    this.updateNetworkInfo();
    if (this.browserConnection?.addEventListener) {
      this.browserConnection.addEventListener('change', this.networkChangeHandler);
    }
    window.addEventListener('online', this.networkChangeHandler);
    window.addEventListener('offline', this.networkChangeHandler);
  }

  private cleanupNetworkSpeedMonitoring() {
    if (this.browserConnection?.removeEventListener) {
      this.browserConnection.removeEventListener('change', this.networkChangeHandler);
    }
    window.removeEventListener('online', this.networkChangeHandler);
    window.removeEventListener('offline', this.networkChangeHandler);
  }

  private updateNetworkInfo() {
    const nav: any = navigator;
    const connection = this.browserConnection || nav?.connection || nav?.mozConnection || nav?.webkitConnection;
    if (!navigator.onLine) {
      this.netSpeedMbps = 0;
      this.netType = 'offline';
      this.netRttMs = null;
      this.updateNetworkWarningState();
      return;
    }
    this.netSpeedMbps = typeof connection?.downlink === 'number' ? connection.downlink : null;
    this.netType = connection?.effectiveType || 'online';
    this.netRttMs = typeof connection?.rtt === 'number' ? connection.rtt : null;
    this.updateNetworkWarningState();
  }

  private updateNetworkWarningState() {
    const minSpeed = allConstant.internetSpeadCheck.netSpeedMbps;
    const maxLatency = allConstant.internetSpeadCheck.latency;
    const type = (this.netType || '').toLowerCase();
    const isSlowType = ['slow-2g', '2g', '3g'].includes(type);
    const isSlowSpeed = this.netSpeedMbps !== null ? this.netSpeedMbps < minSpeed : false;
    const isHighLatency = this.netRttMs !== null ? this.netRttMs > maxLatency : false;
    this.isShowNetWarning = isSlowSpeed || isHighLatency;;
    // this.isShowNetWarning = !navigator.onLine || !this.isOnline || this.isDisconnected || isSlowType || isSlowSpeed || isHighLatency;
  }

  get netWarningMessage(): string {
    if (!navigator.onLine || !this.isOnline || this.isDisconnected) {
      return 'You are disconnected. Trying to reconnect. Please check your internet connection.';
    }

    if (this.netSpeedMbps !== null) {
      return `Network is unstable (${this.netSpeedMbps.toFixed(1)} Mbps).`;
    }

    return 'Network is unstable. Connection quality is low.';
  }

  get networkSpeedLabel(): string {
    if (!navigator.onLine || this.netType === 'offline') {
      return 'OFFLINE';
    }
    if (this.netSpeedMbps !== null) {
      return `${this.netSpeedMbps.toFixed(1)} Mbps`;
    }
    return this.netType ? this.netType.toUpperCase() : 'N/A';
  }
  //#endregion <-------------END NETWORK SPEED SECTION------------->

}

